import React from "react";
import ajax from "./../lib/ajax.js";
import context from "./../lib/context.js";
import immutable from "immutable";
import TCConfirm from "./tc-approval/tc-confirm.jsx";
import TCSummary from "./tc-approval/tc-summary.jsx";

export default class PayrollAdminTCApproval extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            timecards: [],
            isApprovalSuccessful: false,
            errorMessage: null
        };

        this.role = context.getRouteParam(this, "role");
        this.onConfirm = this.onConfirm.bind(this);
    }

    componentDidMount() {
        let self = this;
        context.message({
            show: true, 
            type: "loading", 
            message:"Loading. Please wait..."
        });
        ajax.vm().get("tc-approval/" + this.role)
            .then(function(res) {
                self.setState({timecards: res.data});
                context.message({show:false});
            })
            .catch(function (err) {
                let data = err.response.data;
                if (data.message.toLowerCase().indexOf("unauthorize") > -1)
                    window.location = context.root() + `/../AccessDenied.aspx`;
                else
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
            });
    }

    reloadTimecard() {
        let self = this;
        context.message({
            show: true, 
            type: "loading", 
            message:"Loading. Please wait..."
        });
        ajax.legacy().get(`get-timecard-for-verification/${this.role}`)
            .then(function(res) {               
                self.setState({
                    timecards: res.data, 
                    isApprovalSuccessful: false
                });
                context.message({show:false});
            })
            .catch(function(err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type:"error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    onConfirm(isAgree) {
        if (!isAgree) {
            context.message({
                show: true,
                type:"error",
                message: 'Please check the "Condition of Service" box',
                buttons: "close"
            });
            return false;
        }
        const self = this;
        const clone = immutable.fromJS(this.state).toJS();
        context.message({
            show: true,
            type:"loading",
            message: "Processing. Please wait..."            
        });

        var version = "";
        if (self.props.params.version !== undefined)
            version = self.props.params.version;

        ajax.api().post(`verify-timecard${version}/${self.role}/${self.props.params.submitted}`)
            .then(function(res){
                context.message({
                    show: false
                }); 
                
                self.setState({
                    timecards: res.data, 
                    isApprovalSuccessful: true, 
                    errorMessage: null
                });
            })
            .catch(function(err) {
                context.message({
                    show: false
                });

                let data = err.response.data;
                clone.errorMessage = data.exceptionMessage || data.message;
                clone.isApprovalSuccessful = false;

                // reload timecard(s) because some might have already been stripped off due to recall
                ajax.api().get(`get-timecard-for-verification/${self.role}`)
                    .then(function(res) {
                        clone.timecards = res.data;
                        self.setState(clone);
                    })
                    .catch(function(err) {
                        let data = err.response.data;
                        let errorMsg = data.exceptionMessage || data.message;
                        
                        if (errorMsg != null && errorMsg.indexOf('not found') > 0) {
                            clone.timecards = [];
                            self.setState(clone);
                        }
                    }); // no need to show error for this call, it will overlap the previous error message
            });
    }

    render() {
        if (this.state.isApprovalSuccessful)
            return (
                <div>
                    <TCSummary vm={this.state.timecards} role={this.role} errorMessage={this.state.errorMessage} />
                </div>
                );
        else
            return (
                <div>
                    <TCConfirm vm={this.state.timecards} role={this.role} errorMessage={this.state.errorMessage} onConfirm={this.onConfirm} />
                </div>
                );
    }
}